// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.botonDropdown{
  background-color: #0c1b30 !important;
  border-color: #0c1b30 !important;
}

.btnAddTables{
  background-color: #282c35 !important;
  border-color: #282c35 !important;
}

.generaltablaOrdenes {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.tablaServiciosOrdenes, .tablaRequisicionCompras {
  overflow-x: auto;
  margin-bottom: 0.5rem;
}

.titulo {
  text-align: center;
}

.checksDiv {
  display: grid;
  grid-template-areas: "colorP tonosC";
}

.lblColSer {
  grid-area: colorP;
}

.lblTonosSer {
  grid-area: tonosC;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  /* Opcional: Alinear verticalmente al centro si es necesario */
  align-items: center;
}

.button-container Button {
  margin-right: 0.5rem;
  margin-top: 0.5rem;
}

.divTabla {
  padding: 1rem;
  text-align: center !important;
}

.MuiToolbar-root {
  background-color: #9c182d; /* Cambia el color de fondo a azul */
  color: #fff; /* Cambia el color del texto a blanco */
}

.MuiTableRow-root {
  background-color: rgba(211, 211, 211, 0.267);
}

.MuiTablePagination-toolbar {
  background-color: rgba(211, 211, 211, 0);
  color: #282c35;
}

.imagenesServicio {
  margin-top: 4rem;
  display: flex;
  flex-wrap: wrap;
}

.imagenesServicio p {
  margin-top: -2rem;
  text-align: center;
}

.imagenesServicio div {
  margin-right: 1rem;
}

.btnadd {
  padding: 12.5px 30px;
  border: 0;
  border-radius: 100px;
  margin-left: 0.7rem;
  background-color: #9c182d;
  color: #ffffff;
  font-weight: Bold;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
}

.divButton {
  text-align: right;
  padding-right: 1rem;
  padding-bottom: 0.5rem;
}

.btnadd:hover {
  background-color: #9c182d;
  box-shadow: 10px 10px 13px -11px #9c182d;
  transform: scale(1.1);
}

.btnadd:active {
  background-color: #9c182d;
  transition: all 0.25s;
  -webkit-transition: all 0.25s;
  box-shadow: none;
  transform: scale(0.98);
}

.submit {
  position: relative;
  display: inline-block;
  padding: 12px 24px;
  border: none;
  font-size: 16px;
  border-radius: 100px;
  font-weight: 600;
  color: rgb(255, 255, 255);
  box-shadow: 2px #9c182d;
  background-color: #9c182d;
  cursor: pointer;
  transition: all 0.6s;
}

.submit span:last-child {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 20px;
  background-color: #2196f3;
  border-radius: 50%;
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
}

.submit span:first-child {
  position: relative;
  z-index: 1;
}

.submit:hover {
  color: #fff;
  background-color: #a15561;
  box-shadow: 10px 10px 16px -3px rgba(0, 0, 0, 0.75);
}

.submit:active {
  scale: 0.95;
}

.submit:hover span:last-child {
  width: 150px;
  height: 150px;
  opacity: 1;
}

.divSubmit {
  text-align: center;
}

.formgeneral {
  width: 100%;
  height: auto;
  padding: 30px;
  text-align: left;
  display: grid;
  grid-template-areas:
    "form1 form1 form1"
    "form2 form2 form2"
    "form3 formImagen1 formImagen2"
    "form4 form4 form4"
    "form5 form5 form5";
}

.form1 {
  grid-area: form1;
}

.form2 {
  grid-area: form2;
  display: grid;
  grid-template-areas:
    "fecha localidad doctor"
    "inpFecha txtLocalidad slcDoctor"
    "descripcion descripcion descripcion";
}

.form3 {
  grid-area: form3;
  padding: 1rem;
}

.form4 {
  grid-area: form4;
  display: grid;
  grid-template-areas: "select1 select2 select3";
}

.formImagen1 {
  grid-area: formImagen1;
}

.formImagen2 {
  grid-area: formImagen2;
}

.checkMaterial {
  max-width: 250px;
  text-align: left;
  justify-content: left;
  margin-left: 2rem;
}

.inpFecha {
  max-width: 70%;
}

.txtLocalidad {
  max-width: 80%;
}

.slcDoctor {
  max-width: 95%;
}

.lblDoctorOrden {
  margin-top: 1rem;
  grid-area: doctor;
}

.lblLocalidadOrden {
  margin-top: 1rem;
  grid-area: localidad;
}

.lblFechaOrden {
  margin-top: 1rem;
  grid-area: fecha;
}

.lblDescripcionOrden {
  margin-top: 1rem;
  grid-area: descripcion;
}

.txtDescripcionOrden {
  margin-bottom: 1rem;
}

.slc1 {
  grid-area: select1;
  padding: 1rem;
}

.slc2 {
  grid-area: select2;
  margin-top: 0.5vw;
  padding: 1rem;
}

.slc3 {
  grid-area: select3;
  margin-top: 0.5vw;
  padding: 1rem;
}

.generalEstablecimiento {
  padding: 0.7rem;
}

.contactoCli {
  display: grid;
  grid-template-areas: "tel correo";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.dom1Cli {
  display: grid;
  grid-template-areas: "calle nExt nInt";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.dom2Cli {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas: "colonia estado municipio";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.colonia {
  grid-area: colonia;
}

.estadoCli {
  grid-area: estado;
}

.municipioCli {
  grid-area: municipio;
}

.lblCalle {
  grid-area: calle;
}

.lblnExt {
  grid-area: nExt;
}

.lblnInt {
  grid-area: nInt;
}

.dom3Cli {
  display: grid;
  grid-template-areas: "cp esq";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.lblCP {
  grid-area: cp;
}

.lblTelefono {
  grid-area: tel;
}

.inpTelefono {
  -webkit-appearance: textfield !important;
  margin: 0;
  -moz-appearance: textfield !important;
}
.lblEsquina {
  grid-area: esq;
}

.lblEmail {
  grid-area: correo;
}

.lblHorario {
  grid-area: horario;
}

.generalDoctores {
  padding: 0.2rem;
}

.datosPersonalesDoc {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "pApellido sApellido";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.lblpApellido {
  grid-area: pApellido;
}

.lblsApellido {
  grid-area: sApellido;
}

.datosDoctores {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "nacimiento rfc";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.lblFechaDoc {
  grid-area: nacimiento;
}

.lblRFCDoc {
  grid-area: rfc;
}

.contactoDoc {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-areas: "celular correo";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.lblTelefonoDoc {
  grid-area: celular;
}

.lblCorreoDoc {
  grid-area: correo;
}

.facturacionGeneral {
  padding: 0.7rem;
}

.dom1Facturacion {
  display: grid;
  grid-template-areas: "calleF extF intF";
  grid-gap: 2vw;
  grid-row-gap: 0;
}

.lblCalleFact {
  grid-area: calleF;
}

.lblNumExtFact {
  grid-area: extF;
}

.lblNumIntFact {
  grid-area: intF;
}

.dom2Facturacion {
  display: grid;
  grid-template-areas: "cpF colF munF";
  grid-gap: 2vw;
  grid-row-gap: 0;
}

.lblCPFact {
  grid-area: cpF;
}

.lblColoniaFact {
  grid-area: colF;
}

.lblMunicipioFact {
  grid-area: munF;
}

.pedidosPL {
  display: grid;
  grid-template-areas: "pStock sMinimo";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.lblPedidoStock {
  grid-area: pStock;
}

.lblPedidoMinimo {
  grid-area: sMinimo;
}

.stockPL {
  display: grid;
  grid-template-areas: "stMinimo stMaximo";
  grid-gap: 1vw;
  grid-row-gap: 0;
}

.lblStockMinimo {
  grid-area: stMinimo;
}

.lblStockMaximo {
  grid-area: stMaximo;
}

.generalColorimetria,
.generalPrecios,
.generalSerDentales {
  padding: 0.5rem;
}

.generalReq {
  padding: 0.7rem;
}

.formReq1 {
  display: grid;
  grid-template-areas: "folioReq statusReq fechaReq";
  grid-gap: 2vw;
  grid-row-gap: 0;
}

.lblfolio {
  grid-area: folioReq;
}

.lblStatus {
  grid-area: statusReq;
}

.lblFecha {
  grid-area: fechaReq;
}

.formReq2 {
  display: grid;
  grid-template-areas: "nombreReq departamentoReq";
  grid-gap: 2vw;
  grid-row-gap: 0;
  margin-bottom: 2rem;
}

.lblSolicitante {
  grid-area: nombreReq;
}

.lblDepartamento {
  grid-area: departamentoReq;
}

.btnModal {
  margin-bottom: 0.5rem;
}

.totales {
  text-align: right;
}

.lbltotal {
  padding-bottom: 0%;
  align-items: end;
}

.inpTotalSol {
  max-width: 10rem;
  float: right;
}

h1 {
  text-align: center;
}

.checkbox-container {
  display: grid;
  grid-template-columns: repeat(8, 3rem);
  gap: 0.5rem;
}

.divBotonesC {
  display: grid;
  grid-template-areas: "chk1 chk2";
}

.check1 {
  grid-area: chk1;
}

.check2 {
  grid-area: chk2;
}

.chkModDental {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.imgTipoOS{
  width: 100%;
}

.textTipoDentOS {
  grid-area: textTipo;
  display: flex;
  align-items: center;
  height: 50%;
}


.containerCanvasMap {
  position: relative;
  padding: 50%;
  width: 100%;
  height: auto;
  padding-bottom: 75%;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 1;
}

.canvas-map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}


.containerMapImage {
  position: relative;
  width: 100%; /* Ajusta el ancho al 100% para que el contenedor sea responsive */
  padding-bottom: 60%; /* Ajusta la altura relativa al ancho (60% en este caso) para que el canvas sea responsive */
}

.background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.generalRutas{
  margin: 1vw;
}

.main-header{
  background-color: #0c1b30;
  color: #fff;
}
.navbar-nav{
  color: #fff;
}

.main-sidebar {
  background-color: #0c1b30;
  height: 100%;
}

.barMenuElements{
  max-height: 95vh !important;
  overflow: scroll;
  scrollbar-width: none !important;
}

.modal-header {
  background-color: #9c182d;
  color: #fff;
}

.content-wrapper {
  max-height: 100vh;
  overflow: scroll;
  scrollbar-width: none !important;
}

.barraPrincipal {
  background-color: #0c1b30;
}

.nav-link i{
  color: #fff;
}

.logoPrincipal {
  max-width: 7rem;
  max-height: 5rem;
  margin-bottom: 0%;
  margin-top: 0%;
}

.MuiSvgIcon-root {
  color: #b3b3b3;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide div {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 10px;
  width: 97.5%;
  text-align: center;
  font-size: 18px;
  margin: 1rem;
  box-shadow: 5px 5px 15px gray;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: flex;
  justify-content: center;
  align-items: center;
}

.footerPrincipal {
  background-color: #282c34;
}

.footerPrincipal div {
  text-align: center;
  color: white;
}

.errorSesionBody{
  
  background-color: #f4f4f4;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
}

.error-container {
  text-align: center;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.error-text {
  font-size: 5em;
  color: #f00;
  margin-bottom: 20px;
}

.error-title {
  color: #f00;
  font-size: 3em;
  margin-bottom: 10px;
  font-family: Consolas;
  font-weight: bolder;
}

.error-message {
  font-size: 1.2em;
  color: #333; 
  margin-bottom: 20px;
  
}

.error-link {
  color: #007bff;
  font-weight: bold;
  transition: color 0.3s ease;
}

.error-link:hover {
  color: #02448b; 
}

.principalError {
  background-color: rgb(183, 183, 183);
  width: 100%;
  height: 90vh;
}

.errorMessage {
  background-color: rgb(183, 183, 183);
  color: white;
  display: grid;
  grid-template-areas:
    "imagen imagen"
    "imagenError texto";
  align-items: center;
  justify-content: center;
}

.imagenbajaError {
  grid-area: imagen;
  width: 100%;
  text-align: center;
  margin-top: 2rem;
}

.imagen404 {
  width: 10vw;
  height: 10vw;
}

.imgError {
  width: 100%;
  grid-area: imagenError;
  text-align: right;
}

.imagenError {
  width: 5vw;
  height: 6vw;
  margin-top: 3rem;
}

.errorText {
  grid-area: texto;
  height: 6vw;
  margin-top: 3rem;
  display: flex;
  align-items: center;
}

.errorText h3 {
  font-weight: bold;
  font-family: Consolas;
  text-align: center;
  color: #0c1b30;
}

.botonesAccion {
  display: flex;
}

.btnDelete {
  margin-right: 0.2rem;
}

.perfilCierreBarra{
  width: 100%;
}

.perfilCierreBarra Button{
  color: #fff;
  font-weight: bold;
  text-decoration: none;
  --bs-btn-hover-color: #fff;
  --bs-btn-active-color: #fff;
}

.btn-link{
  color: #fff;
  font-weight: bold;
}

.iconoCerrarS{
  color: red;
}

.inicioNav{
  background-color: #9c182d !important;
}

.tss-1vd39vz-MUIDataTableBodyCell-stackedCommon {
  text-align: center !important;
}

.tss-178gktx-MUIDataTableHeadCell-contentWrapper {
  justify-content: center !important;
}

.css-1ex1afd-MuiTableCell-root {
  text-align: center !important;
}

.css-1ygcj2i-MuiTableCell-root {
  text-align: center !important;
  text-transform: uppercase;
}

.tss-1cdcmys-MUIDataTable-responsiveBase{
  max-height: 60vh !important;
}

.css-q34dxg{
  text-align: center !important;

}

.tss-1t6h0i4-MUIDataTableToolbar-titleRoot{
  text-align: left;
}

@media screen and (max-width: 990px) {
  .sidebar-open .menuH{
    margin-left: 32%;
    display: none;
  }
  
  .content-wrapper{
    min-height: 60vh !important;
  }

}

@media screen and (max-width: 770px) {
  .sidebar-open .menuH{
    margin-left: 62%;
    display: none;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;EAC3B,8DAA8D;EAC9D,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB,EAAE,oCAAoC;EAC/D,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EAGzB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EAGzB,mDAAmD;AACrD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb;;;;;uBAKqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb;;;yCAGuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,+CAA+C;EAC/C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,SAAS;EACT,qCAAqC;AACvC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qCAAqC;EACrC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,4BAA4B;EAC5B,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,WAAW,EAAE,kEAAkE;EAC/E,mBAAmB,EAAE,4FAA4F;AACnH;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;;EAEhB,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;;AAErB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb;;uBAEqB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;;AAE/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;AAEF;;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;;AAEF","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.botonDropdown{\n  background-color: #0c1b30 !important;\n  border-color: #0c1b30 !important;\n}\n\n.btnAddTables{\n  background-color: #282c35 !important;\n  border-color: #282c35 !important;\n}\n\n.generaltablaOrdenes {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.tablaServiciosOrdenes, .tablaRequisicionCompras {\n  overflow-x: auto;\n  margin-bottom: 0.5rem;\n}\n\n.titulo {\n  text-align: center;\n}\n\n.checksDiv {\n  display: grid;\n  grid-template-areas: \"colorP tonosC\";\n}\n\n.lblColSer {\n  grid-area: colorP;\n}\n\n.lblTonosSer {\n  grid-area: tonosC;\n}\n\n.button-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  /* Opcional: Alinear verticalmente al centro si es necesario */\n  align-items: center;\n}\n\n.button-container Button {\n  margin-right: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.divTabla {\n  padding: 1rem;\n  text-align: center !important;\n}\n\n.MuiToolbar-root {\n  background-color: #9c182d; /* Cambia el color de fondo a azul */\n  color: #fff; /* Cambia el color del texto a blanco */\n}\n\n.MuiTableRow-root {\n  background-color: rgba(211, 211, 211, 0.267);\n}\n\n.MuiTablePagination-toolbar {\n  background-color: rgba(211, 211, 211, 0);\n  color: #282c35;\n}\n\n.imagenesServicio {\n  margin-top: 4rem;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.imagenesServicio p {\n  margin-top: -2rem;\n  text-align: center;\n}\n\n.imagenesServicio div {\n  margin-right: 1rem;\n}\n\n.btnadd {\n  padding: 12.5px 30px;\n  border: 0;\n  border-radius: 100px;\n  margin-left: 0.7rem;\n  background-color: #9c182d;\n  color: #ffffff;\n  font-weight: Bold;\n  transition: all 0.5s;\n  -webkit-transition: all 0.5s;\n}\n\n.divButton {\n  text-align: right;\n  padding-right: 1rem;\n  padding-bottom: 0.5rem;\n}\n\n.btnadd:hover {\n  background-color: #9c182d;\n  -webkit-box-shadow: 10px 10px 13px -11px #9c182d;\n  -moz-box-shadow: 10px 10px 13px -11px #9c182d;\n  box-shadow: 10px 10px 13px -11px #9c182d;\n  transform: scale(1.1);\n}\n\n.btnadd:active {\n  background-color: #9c182d;\n  transition: all 0.25s;\n  -webkit-transition: all 0.25s;\n  box-shadow: none;\n  transform: scale(0.98);\n}\n\n.submit {\n  position: relative;\n  display: inline-block;\n  padding: 12px 24px;\n  border: none;\n  font-size: 16px;\n  border-radius: 100px;\n  font-weight: 600;\n  color: rgb(255, 255, 255);\n  box-shadow: 2px #9c182d;\n  background-color: #9c182d;\n  cursor: pointer;\n  transition: all 0.6s;\n}\n\n.submit span:last-child {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 20px;\n  height: 20px;\n  background-color: #2196f3;\n  border-radius: 50%;\n  opacity: 0;\n  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.submit span:first-child {\n  position: relative;\n  z-index: 1;\n}\n\n.submit:hover {\n  color: #fff;\n  background-color: #a15561;\n  -webkit-box-shadow: 10px 10px 16px -3px rgba(0, 0, 0, 0.75);\n  -moz-box-shadow: 10px 10px 16px -3px rgba(0, 0, 0, 0.75);\n  box-shadow: 10px 10px 16px -3px rgba(0, 0, 0, 0.75);\n}\n\n.submit:active {\n  scale: 0.95;\n}\n\n.submit:hover span:last-child {\n  width: 150px;\n  height: 150px;\n  opacity: 1;\n}\n\n.divSubmit {\n  text-align: center;\n}\n\n.formgeneral {\n  width: 100%;\n  height: auto;\n  padding: 30px;\n  text-align: left;\n  display: grid;\n  grid-template-areas:\n    \"form1 form1 form1\"\n    \"form2 form2 form2\"\n    \"form3 formImagen1 formImagen2\"\n    \"form4 form4 form4\"\n    \"form5 form5 form5\";\n}\n\n.form1 {\n  grid-area: form1;\n}\n\n.form2 {\n  grid-area: form2;\n  display: grid;\n  grid-template-areas:\n    \"fecha localidad doctor\"\n    \"inpFecha txtLocalidad slcDoctor\"\n    \"descripcion descripcion descripcion\";\n}\n\n.form3 {\n  grid-area: form3;\n  padding: 1rem;\n}\n\n.form4 {\n  grid-area: form4;\n  display: grid;\n  grid-template-areas: \"select1 select2 select3\";\n}\n\n.formImagen1 {\n  grid-area: formImagen1;\n}\n\n.formImagen2 {\n  grid-area: formImagen2;\n}\n\n.checkMaterial {\n  max-width: 250px;\n  text-align: left;\n  justify-content: left;\n  margin-left: 2rem;\n}\n\n.inpFecha {\n  max-width: 70%;\n}\n\n.txtLocalidad {\n  max-width: 80%;\n}\n\n.slcDoctor {\n  max-width: 95%;\n}\n\n.lblDoctorOrden {\n  margin-top: 1rem;\n  grid-area: doctor;\n}\n\n.lblLocalidadOrden {\n  margin-top: 1rem;\n  grid-area: localidad;\n}\n\n.lblFechaOrden {\n  margin-top: 1rem;\n  grid-area: fecha;\n}\n\n.lblDescripcionOrden {\n  margin-top: 1rem;\n  grid-area: descripcion;\n}\n\n.txtDescripcionOrden {\n  margin-bottom: 1rem;\n}\n\n.slc1 {\n  grid-area: select1;\n  padding: 1rem;\n}\n\n.slc2 {\n  grid-area: select2;\n  margin-top: 0.5vw;\n  padding: 1rem;\n}\n\n.slc3 {\n  grid-area: select3;\n  margin-top: 0.5vw;\n  padding: 1rem;\n}\n\n.generalEstablecimiento {\n  padding: 0.7rem;\n}\n\n.contactoCli {\n  display: grid;\n  grid-template-areas: \"tel correo\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.dom1Cli {\n  display: grid;\n  grid-template-areas: \"calle nExt nInt\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.dom2Cli {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-areas: \"colonia estado municipio\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.colonia {\n  grid-area: colonia;\n}\n\n.estadoCli {\n  grid-area: estado;\n}\n\n.municipioCli {\n  grid-area: municipio;\n}\n\n.lblCalle {\n  grid-area: calle;\n}\n\n.lblnExt {\n  grid-area: nExt;\n}\n\n.lblnInt {\n  grid-area: nInt;\n}\n\n.dom3Cli {\n  display: grid;\n  grid-template-areas: \"cp esq\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.lblCP {\n  grid-area: cp;\n}\n\n.lblTelefono {\n  grid-area: tel;\n}\n\n.inpTelefono {\n  -webkit-appearance: textfield !important;\n  margin: 0;\n  -moz-appearance: textfield !important;\n}\n.lblEsquina {\n  grid-area: esq;\n}\n\n.lblEmail {\n  grid-area: correo;\n}\n\n.lblHorario {\n  grid-area: horario;\n}\n\n.generalDoctores {\n  padding: 0.2rem;\n}\n\n.datosPersonalesDoc {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-areas: \"pApellido sApellido\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.lblpApellido {\n  grid-area: pApellido;\n}\n\n.lblsApellido {\n  grid-area: sApellido;\n}\n\n.datosDoctores {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-areas: \"nacimiento rfc\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.lblFechaDoc {\n  grid-area: nacimiento;\n}\n\n.lblRFCDoc {\n  grid-area: rfc;\n}\n\n.contactoDoc {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-areas: \"celular correo\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.lblTelefonoDoc {\n  grid-area: celular;\n}\n\n.lblCorreoDoc {\n  grid-area: correo;\n}\n\n.facturacionGeneral {\n  padding: 0.7rem;\n}\n\n.dom1Facturacion {\n  display: grid;\n  grid-template-areas: \"calleF extF intF\";\n  grid-gap: 2vw;\n  grid-row-gap: 0;\n}\n\n.lblCalleFact {\n  grid-area: calleF;\n}\n\n.lblNumExtFact {\n  grid-area: extF;\n}\n\n.lblNumIntFact {\n  grid-area: intF;\n}\n\n.dom2Facturacion {\n  display: grid;\n  grid-template-areas: \"cpF colF munF\";\n  grid-gap: 2vw;\n  grid-row-gap: 0;\n}\n\n.lblCPFact {\n  grid-area: cpF;\n}\n\n.lblColoniaFact {\n  grid-area: colF;\n}\n\n.lblMunicipioFact {\n  grid-area: munF;\n}\n\n.pedidosPL {\n  display: grid;\n  grid-template-areas: \"pStock sMinimo\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.lblPedidoStock {\n  grid-area: pStock;\n}\n\n.lblPedidoMinimo {\n  grid-area: sMinimo;\n}\n\n.stockPL {\n  display: grid;\n  grid-template-areas: \"stMinimo stMaximo\";\n  grid-gap: 1vw;\n  grid-row-gap: 0;\n}\n\n.lblStockMinimo {\n  grid-area: stMinimo;\n}\n\n.lblStockMaximo {\n  grid-area: stMaximo;\n}\n\n.generalColorimetria,\n.generalPrecios,\n.generalSerDentales {\n  padding: 0.5rem;\n}\n\n.generalReq {\n  padding: 0.7rem;\n}\n\n.formReq1 {\n  display: grid;\n  grid-template-areas: \"folioReq statusReq fechaReq\";\n  grid-gap: 2vw;\n  grid-row-gap: 0;\n}\n\n.lblfolio {\n  grid-area: folioReq;\n}\n\n.lblStatus {\n  grid-area: statusReq;\n}\n\n.lblFecha {\n  grid-area: fechaReq;\n}\n\n.formReq2 {\n  display: grid;\n  grid-template-areas: \"nombreReq departamentoReq\";\n  grid-gap: 2vw;\n  grid-row-gap: 0;\n  margin-bottom: 2rem;\n}\n\n.lblSolicitante {\n  grid-area: nombreReq;\n}\n\n.lblDepartamento {\n  grid-area: departamentoReq;\n}\n\n.btnModal {\n  margin-bottom: 0.5rem;\n}\n\n.totales {\n  text-align: right;\n}\n\n.lbltotal {\n  padding-bottom: 0%;\n  align-items: end;\n}\n\n.inpTotalSol {\n  max-width: 10rem;\n  float: right;\n}\n\nh1 {\n  text-align: center;\n}\n\n.checkbox-container {\n  display: grid;\n  grid-template-columns: repeat(8, 3rem);\n  gap: 0.5rem;\n}\n\n.divBotonesC {\n  display: grid;\n  grid-template-areas: \"chk1 chk2\";\n}\n\n.check1 {\n  grid-area: chk1;\n}\n\n.check2 {\n  grid-area: chk2;\n}\n\n.chkModDental {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.imgTipoOS{\n  width: 100%;\n}\n\n.textTipoDentOS {\n  grid-area: textTipo;\n  display: flex;\n  align-items: center;\n  height: 50%;\n}\n\n\n.containerCanvasMap {\n  position: relative;\n  padding: 50%;\n  width: 100%;\n  height: auto;\n  padding-bottom: 75%;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center center;\n  z-index: 1;\n}\n\n.canvas-map {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n}\n\n\n.containerMapImage {\n  position: relative;\n  width: 100%; /* Ajusta el ancho al 100% para que el contenedor sea responsive */\n  padding-bottom: 60%; /* Ajusta la altura relativa al ancho (60% en este caso) para que el canvas sea responsive */\n}\n\n.background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.generalRutas{\n  margin: 1vw;\n}\n\n.main-header{\n  background-color: #0c1b30;\n  color: #fff;\n}\n.navbar-nav{\n  color: #fff;\n}\n\n.main-sidebar {\n  background-color: #0c1b30;\n  height: 100%;\n}\n\n.barMenuElements{\n  max-height: 95vh !important;\n  overflow: scroll;\n  scrollbar-width: none !important;\n}\n\n.modal-header {\n  background-color: #9c182d;\n  color: #fff;\n}\n\n.content-wrapper {\n  max-height: 100vh;\n  overflow: scroll;\n  scrollbar-width: none !important;\n}\n\n.barraPrincipal {\n  background-color: #0c1b30;\n}\n\n.nav-link i{\n  color: #fff;\n}\n\n.logoPrincipal {\n  max-width: 7rem;\n  max-height: 5rem;\n  margin-bottom: 0%;\n  margin-top: 0%;\n}\n\n.MuiSvgIcon-root {\n  color: #b3b3b3;\n}\n\n.swiper-slide img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.swiper-slide div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.7);\n  padding: 10px;\n  width: 97.5%;\n  text-align: center;\n  font-size: 18px;\n  margin: 1rem;\n  box-shadow: 5px 5px 15px gray;\n}\n\n.swiper-slide {\n  text-align: center;\n  font-size: 18px;\n  background: #fff;\n\n  /* Center slide text vertically */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.footerPrincipal {\n  background-color: #282c34;\n}\n\n.footerPrincipal div {\n  text-align: center;\n  color: white;\n}\n\n.errorSesionBody{\n  \n  background-color: #f4f4f4;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80vh;\n}\n\n.error-container {\n  text-align: center;\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.error-text {\n  font-size: 5em;\n  color: #f00;\n  margin-bottom: 20px;\n}\n\n.error-title {\n  color: #f00;\n  font-size: 3em;\n  margin-bottom: 10px;\n  font-family: Consolas;\n  font-weight: bolder;\n}\n\n.error-message {\n  font-size: 1.2em;\n  color: #333; \n  margin-bottom: 20px;\n  \n}\n\n.error-link {\n  color: #007bff;\n  font-weight: bold;\n  transition: color 0.3s ease;\n}\n\n.error-link:hover {\n  color: #02448b; \n}\n\n.principalError {\n  background-color: rgb(183, 183, 183);\n  width: 100%;\n  height: 90vh;\n}\n\n.errorMessage {\n  background-color: rgb(183, 183, 183);\n  color: white;\n  display: grid;\n  grid-template-areas:\n    \"imagen imagen\"\n    \"imagenError texto\";\n  align-items: center;\n  justify-content: center;\n}\n\n.imagenbajaError {\n  grid-area: imagen;\n  width: 100%;\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.imagen404 {\n  width: 10vw;\n  height: 10vw;\n}\n\n.imgError {\n  width: 100%;\n  grid-area: imagenError;\n  text-align: right;\n}\n\n.imagenError {\n  width: 5vw;\n  height: 6vw;\n  margin-top: 3rem;\n}\n\n.errorText {\n  grid-area: texto;\n  height: 6vw;\n  margin-top: 3rem;\n  display: flex;\n  align-items: center;\n}\n\n.errorText h3 {\n  font-weight: bold;\n  font-family: Consolas;\n  text-align: center;\n  color: #0c1b30;\n}\n\n.botonesAccion {\n  display: flex;\n}\n\n.btnDelete {\n  margin-right: 0.2rem;\n}\n\n.perfilCierreBarra{\n  width: 100%;\n}\n\n.perfilCierreBarra Button{\n  color: #fff;\n  font-weight: bold;\n  text-decoration: none;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-active-color: #fff;\n}\n\n.btn-link{\n  color: #fff;\n  font-weight: bold;\n}\n\n.iconoCerrarS{\n  color: red;\n}\n\n.inicioNav{\n  background-color: #9c182d !important;\n}\n\n.tss-1vd39vz-MUIDataTableBodyCell-stackedCommon {\n  text-align: center !important;\n}\n\n.tss-178gktx-MUIDataTableHeadCell-contentWrapper {\n  justify-content: center !important;\n}\n\n.css-1ex1afd-MuiTableCell-root {\n  text-align: center !important;\n}\n\n.css-1ygcj2i-MuiTableCell-root {\n  text-align: center !important;\n  text-transform: uppercase;\n}\n\n.tss-1cdcmys-MUIDataTable-responsiveBase{\n  max-height: 60vh !important;\n}\n\n.css-q34dxg{\n  text-align: center !important;\n\n}\n\n.tss-1t6h0i4-MUIDataTableToolbar-titleRoot{\n  text-align: left;\n}\n\n@media screen and (max-width: 990px) {\n  .sidebar-open .menuH{\n    margin-left: 32%;\n    display: none;\n  }\n  \n  .content-wrapper{\n    min-height: 60vh !important;\n  }\n\n}\n\n@media screen and (max-width: 770px) {\n  .sidebar-open .menuH{\n    margin-left: 62%;\n    display: none;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
